
import routeReplaceSelf from '@/utils/routeReplaceSelf';
//TODO 后续废弃
const custApUpgrade = {
    path: "custApUpgrade",
    name: "custApUpgrade",
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'afterSales',
        icon: 'HSIconfont hs-icon-a-firmwareinfo',
        showRealm: ['SYSTEM']
    },
    children: [
        {
            path: 'custApBatchUpgrade',
            name: 'custApBatchUpgrade',
            component: routeReplaceSelf(() => import('@/views/custApBatchUpgrade/index.vue')),
            meta: { code: 'afterSales:customerApUpgrade' },
            children: [
                {
                    path: 'custApUpgradeAdd',
                    name: 'custApUpgradeAdd',
                    hidden: true,
                    component: () => import('@/views/custApBatchUpgrade/components/Add'),
                    meta: {
                        code: 'afterSales_customerApUpgrade_create',
                        activeMenu: 'custApBatchUpgrade',
                    },
                },
            ]
        }
    ]
};
export default custApUpgrade;
